import "./index.scss";

import React from "react";
import { connect } from "react-redux";
import Header from "./fragments/Header"
import Body from "./fragments/Body"
import Attachment from "./fragments/Attachment"
import Axios from "Source/axiosPool";

@connect((store) => {
    return {
        task: store.task,
    }
})

class ViewEmail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            user: null
        }
        this.fetchEmail = this.fetchEmail.bind(this)
    }
    componentDidMount() {
        console.log("mounting component view email")
        const location = Object.assign({}, window.location);
        const qs = new URLSearchParams(location.search);
        const id = qs.get("id");
        if(id) {
            localStorage.setItem("emailId", id)
            this.fetchEmail(id)
            window.history.pushState({}, "", window.location.href.split('?')[0] );
        } else {
           const conId = localStorage.getItem("emailId")
           if(conId) {
            this.fetchEmail(conId)
           } else {
            window.location.href = "./account"
           }
          
        }  
    }


    fetchEmail(id) {
        Axios.get("api/emails", { emailId: id }).then(
            res => {

                if (res) {
                    const result = res.data.result
                    this.setState({
                        data: result,
                    })
                }

            }
        )
    }
    render() {
        const attachments = this.state.data && this.state.data.attachments ? JSON.parse(this.state.data.attachments) : []
        return (
            <div class="emailPageViewer">
                {this.state.data ?
                    <React.Fragment>
                        <Header data={this.state.data} />
                        <Body html={this.state.data.html} />
                        <Attachment documents={attachments} />
                    </React.Fragment> : <div />
                }
            </div>
        );
    }
}

export default ViewEmail;